<ng-container *ngIf="{ loading: hideAllJobsLoading$ | async } as state">
  <button
    data-cy="hide-all-requests-button"
    type="button"
    class="outline-pill-button hide-all-jobs-button"
    [disabled]="state.loading"
    (click)="onClick()">
    <span class="hide-all-jobs-button__inner">
      <span class="hide-all-jobs-button__label">{{
        ("hideAllRequests" | i18n) || "Alle verpassten Dienste ausblenden"
      }}</span>
      <mat-spinner
        *ngIf="state.loading"
        class="hide-all-jobs-button__spinner"
        diameter="20"></mat-spinner>
    </span>
  </button>
</ng-container>
